import { LinkTo } from '@ember/routing';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import {
  PrismCard,
  PrismLoadingBar,
  PrismMetricBlock,
} from '@mylighthouse/prism-ember';
import { formatNumber, t } from 'ember-intl';
import { compsetDifferenceBackground } from 'lumen/utils/compset-difference';
import { OD_API_DATA_KEYS } from 'lumen/utils/constants/overview-dashboard-constants';
import { generateRatesCalendarRedirectUrlQueryParams } from 'lumen/utils/overview-dashboard/generate-rates-redirect-url-query-params';

interface HotelOverviewDashboardTilesMarketTrendsPriceDifferenceAggregatedViewSignature {
  Args: {
    compsetId: unknown;
    data: unknown;
    isLoading: unknown;
    otaId: unknown;
    rateParam: unknown;
    selectedRange: unknown;
    tileId: unknown;
  };
}

export default class HotelOverviewDashboardTilesMarketTrendsPriceDifferenceAggregatedView extends Component<HotelOverviewDashboardTilesMarketTrendsPriceDifferenceAggregatedViewSignature> {
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];
  @service declare odSelections: Services['od-selections'];

  // The redirect link redirects the user to Rates Insight table view
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get kpiRedirectUrlQueryParams() {
    return generateRatesCalendarRedirectUrlQueryParams(
      this.hotelAndMarketService,
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      this.args.selectedRange.start.format('YYYY-MM'),
      // @ts-expect-error: Incorrect type
      this.args.rateParam,
      this.args.otaId,
      this.args.compsetId,
    );
  }

  // Price difference value text color should follow the same colors as in Rates chart
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get priceDifferenceTextColor() {
    const lowerLimit =
      this.hotelAndMarketService.hotel?.calendarColorLowerLimit;
    const upperLimit =
      this.hotelAndMarketService.hotel?.calendarColorUpperLimit;

    // @ts-expect-error: Incorrect type
    return compsetDifferenceBackground(
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      this.priceDifferenceValue,
      lowerLimit,
      upperLimit,
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get priceDifferenceValue() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return this.args.data.getDataValueFromKey(
      this.odSelections,
      OD_API_DATA_KEYS.comp_pricing_diff,
    );
  }

  <template>
    <PrismCard
      class="prism-card--od-kpi prism-card--od-price-diff-aggregated-view"
    >
      <:header as |Header|>
        <Header.title>
          {{t "overview_dashboard.kpi.price_difference"}}
        </Header.title>
      </:header>
      <:content>
        <div
          class="od-kpi-content prism-card--od-kpi--price-difference-aggregated flex flex-col"
        >
          {{#if @isLoading}}
            <PrismLoadingBar />
          {{else}}
            <PrismMetricBlock @align="left">
              <:value>
                <span
                  class="text-400--bold price-difference-text-color
                    {{this.priceDifferenceTextColor}}"
                >
                  {{formatNumber
                    this.priceDifferenceValue
                    signDisplay="always"
                    style="percent"
                  }}
                </span>
              </:value>
              <:label>
                {{t "overview_dashboard.kpi.subtitle.vs_compset"}}
              </:label>
            </PrismMetricBlock>
            <div class="redirect-link-container">
              <LinkTo
                @model={{this.hotelAndMarketService.hotel.id}}
                @query={{this.kpiRedirectUrlQueryParams}}
                @route="hotel.rates"
                class="prism-link prism-link--standalone"
                data-event-id="hotel_overview-kpi_main_redirect-click"
                data-event-value={{@tileId}}
                target="_blank"
              >
                {{t "overview_dashboard.kpi.link.rate"}}
              </LinkTo>
            </div>
          {{/if}}
        </div>
      </:content>
    </PrismCard>
  </template>
}
